import { IFeatureFlags } from "../types/AppConfig";

export const featureIsEnabled = (feature: keyof IFeatureFlags): boolean =>
  true === window.__APP_CONFIG?.features?.[feature];
